import React, { useState, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { FiShoppingCart, FiArrowLeft, FiCheck } from 'react-icons/fi';
import Loader from '../components/Loader';
import { useApp } from '../context/AppContext';
import API from '../services/api';

const ProductDetail = () => {
  const { id } = useParams();
  const [product, setProduct] = useState(null);
  const [loading, setLoading] = useState(true);
  const [selectedSize, setSelectedSize] = useState('M');
  const [added, setAdded] = useState(false);
  const { addToCart } = useApp();
  const navigate = useNavigate();

  const sizes = ['XS', 'S', 'M', 'L', 'XL', 'XXL'];

  useEffect(() => {
    const fetchProduct = async () => {
      try {
        const res = await API.get(`/products/${id}`);
        setProduct(res.data);
      } catch (error) {
        console.error('Erreur chargement produit:', error);
      } finally {
        setLoading(false);
      }
    };
    fetchProduct();
  }, [id]);

  const handleAddToCart = () => {
    addToCart(product, selectedSize);
    setAdded(true);
    setTimeout(() => setAdded(false), 2000);
  };

  if (loading) return <Loader />;
  if (!product) return <div className="text-center py-20 text-gray-500">Produit non trouvé.</div>;

  return (
    <div className="max-w-6xl mx-auto px-4 py-12">
      
      {/* Retour */}
      <button
        onClick={() => navigate(-1)}
        className="flex items-center gap-2 text-gray-500 hover:text-primary transition mb-8"
      >
        <FiArrowLeft size={18} />
        Retour
      </button>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-12">
        
        {/* Image */}
        <div className="bg-gray-50 rounded-2xl overflow-hidden h-96 md:h-auto">
          <img
            src={product.image}
            alt={product.name}
            className="w-full h-full object-cover object-top"
          />
        </div>

        {/* Infos */}
        <div>
          <span className="text-secondary font-semibold uppercase text-sm tracking-wide">
            {product.category}
          </span>
          <h1 className="text-3xl font-bold text-gray-800 mt-2 mb-4">
            {product.name}
          </h1>
          <p className="text-gray-600 leading-relaxed mb-6">
            {product.description}
          </p>
          <p className="text-3xl font-bold text-primary mb-8">
            {product.price.toLocaleString()} FCFA
          </p>

          {/* Tailles */}
          <div className="mb-8">
            <p className="text-gray-700 font-semibold mb-3">
              Taille : <span className="text-primary">{selectedSize}</span>
            </p>
            <div className="flex gap-2 flex-wrap">
              {sizes.map((size) => (
                <button
                  key={size}
                  onClick={() => setSelectedSize(size)}
                  className={`w-12 h-12 rounded-xl font-semibold text-sm transition ${
                    selectedSize === size
                      ? 'bg-primary text-white'
                      : 'bg-gray-100 text-gray-700 hover:bg-gray-200'
                  }`}
                >
                  {size}
                </button>
              ))}
            </div>
          </div>

          {/* Stock */}
          <p className="text-sm text-gray-500 mb-6">
            Stock disponible : <span className="font-semibold text-gray-700">{product.stock} articles</span>
          </p>

          {/* Bouton */}
          <button
            onClick={handleAddToCart}
            disabled={product.stock === 0}
            className={`w-full py-4 rounded-xl font-bold text-lg transition flex items-center justify-center gap-3 ${
              added
                ? 'bg-green-500 text-white'
                : 'bg-primary text-white hover:bg-blue-800'
            } disabled:opacity-50 disabled:cursor-not-allowed`}
          >
            {added ? (
              <>
                <FiCheck size={22} />
                Ajouté au panier
              </>
            ) : (
              <>
                <FiShoppingCart size={22} />
                Ajouter au panier
              </>
            )}
          </button>
        </div>
      </div>
    </div>
  );
};

export default ProductDetail;